import Context from '@/ViewModels/Context';
import ComponentManager from '@/Management/ComponentManager';

export default class CustomContext extends Context {

    constructor(params) {
        super(params);
    }

}

ComponentManager.setViewModel('CustomContext', CustomContext, 'RADPresentation.HTMLClient.DefaultViewExtensions');